module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('transition-group', {
    staticClass: "notifications",
    attrs: {
      "tag": "div",
      "name": "notification-transition"
    }
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('notification', {
      key: notification.id,
      attrs: {
        "notification": notification
      },
      on: {
        "close-notification": _vm.removeNotification
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee672340","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/notifications/Notifications.vue
// module id = BgA6
// module chunks = 0 1